import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
} from '@angular/core';
import { IGruposRentabilidadeResponse } from '../../../../core/settings/grupos-rentabilidade/interfaces/grupos-rentabilidade-response.interface';
import { IDNAExpectativas } from '../../../dnas/interfaces/dna-expectativas.interface';
import { IItemDNA } from '../../interfaces/item-dna.interface';
import { IPLM } from '../../interfaces/plm.interface';
import {
  ILinhaHeranca,
  IPopulacaoMedida,
  montarLinhasHeranca,
} from '../../utils/linhas-heranca.util';

@Component({
  selector: 'sgt-item-dna-heranca',
  templateUrl: './item-dna-heranca.component.html',
  styleUrls: ['./item-dna-heranca.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ItemDnaHerancaComponent implements OnChanges {
  @Input() dna: IItemDNA | null = null;
  @Input() expectativas: IDNAExpectativas | null = null;
  @Input() valoresDoItem: Partial<IPLM> | null = null;
  @Input() gruposRentabilidade: IGruposRentabilidadeResponse[] = [];
  @Input() idGrupoRentabilidade: number | null = null;
  @Input() populacaoDoItem: IPopulacaoMedida | null = null;
  @Input() podeEditar = true;

  @Output() vincular = new EventEmitter<void>();
  @Output() trocar = new EventEmitter<void>();
  @Output() desvincular = new EventEmitter<void>();
  @Output() abrirDna = new EventEmitter<number>();

  linhas: ILinhaHeranca[] = [];

  get temDna(): boolean {
    return !!this.dna;
  }

  get temMutacao(): boolean {
    return this.linhas.some((linha) => linha.mutacao);
  }

  get parametrosMutados(): string {
    return this.linhas
      .filter((linha) => linha.mutacao)
      .map((linha) => linha.label)
      .join(', ');
  }

  ngOnChanges(): void {
    this.linhas = this.dna
      ? montarLinhasHeranca({
          dna: this.dna,
          item: this.valoresDoItem ?? {},
          expectativas: this.expectativas,
          gruposRentabilidade: this.gruposRentabilidade,
          idGrupoRentabilidadeItem: this.idGrupoRentabilidade,
          populacaoDoItem: this.populacaoDoItem,
        })
      : [];
  }

  onAbrirDna(): void {
    if (this.dna) {
      this.abrirDna.emit(this.dna.id);
    }
  }

  trackByNumero(_index: number, linha: ILinhaHeranca): number {
    return linha.numero;
  }
}
